export default __webpack_public_path__ + "static/media/expand.aaf723c9.svg";